import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import Swal from 'sweetalert2';
import { Form, Button, Container, Row, Col } from "react-bootstrap";
import "bootstrap/dist/css/bootstrap.min.css";
import "bootstrap-icons/font/bootstrap-icons.css";
import "./Login.css";
import Navbar from "../../Pages/Navbar/Navbar";
import BaseUrl from '../../ApiServices/BaseUrl';
import BaseUrl_1 from '../../ApiServices/Log_BaseUrl';
import logo from '../Images/GudnetNewLogo.webp';
import { useLocation } from "react-router-dom";

const LoginPage = () => {
    const [email, setEmail] = useState("");
    const [password, setPassword] = useState("");
    const [errorMsg, setErrorMsg] = useState("");
    const navigate = useNavigate();
    const [showPassword, setShowPassword] = useState(false);
    const location = useLocation();

    useEffect(() => {
        const urlParams = new URLSearchParams(location.search);
        const emailFromUrl = urlParams.get('email');

        if (emailFromUrl) {
            setEmail(decodeURIComponent(emailFromUrl));
        }
    }, [location]);

    const handleLogin = async (e) => {
        e.preventDefault();
        const normalizedEmail = email.trim();

        try {
            const res = await fetch(`${BaseUrl}/login`, {
                method: "POST",
                headers: { "Content-Type": "application/json" },
                body: JSON.stringify({ email: normalizedEmail, password }),
            });

            const data = await res.json();

            if (!res.ok) {
                setErrorMsg(data.message || "Login failed");
            } else {
                // Store user in localStorage
                localStorage.setItem("user", JSON.stringify(data.user));
                localStorage.setItem("userId", data.user.id);
                localStorage.setItem("userPlan", data.user.plan_name);
                localStorage.setItem("userStartDate", data.user.plan_startdate);
                localStorage.setItem("userEnddate", data.user.plan_enddate);

                console.log("Logged in user ID:", data.user.id);

                // Get device info
                const userAgent = navigator.userAgent;
                let device = "Unknown";

                // Detect browser/device
                if (userAgent.includes("Chrome")) {
                    device = "Chrome";
                } else if (userAgent.includes("Firefox")) {
                    device = "Firefox";
                } else if (userAgent.includes("Safari")) {
                    device = "Safari";
                } else if (userAgent.includes("Edge")) {
                    device = "Edge";
                } else if (/Android/i.test(userAgent)) {
                    device = "Android";
                } else if (/iPhone|iPad|iPod/i.test(userAgent)) {
                    device = "iOS";
                }

                // Get IP address (Note: This requires a backend service for accurate IP)
                // For now, we'll use a placeholder or try to get from public API
                let ipAddress = "Not Available";

                // You can use a service to get IP if needed
                // Example: const ipResponse = await fetch('https://api.ipify.org?format=json');
                // const ipData = await ipResponse.json();
                // ipAddress = ipData.ip;

                // Prepare activity log data
                const activityLogData = {
                    userId: data.user.id,
                    userName: data.user.first_name + " " + (data.user.last_name || ""),
                    role: data.user.role,
                    action_id: 1, // Assuming 1 for Login action
                    module_id: 3, // Assuming 1 for Authentication module
                    description: "User logged in successfully",
                    ipAddress: ipAddress,
                    device: device,
                    status: "SUCCESS"
                };

                try {
                    // Call activity log API - don't wait for this to complete
                    // Use setTimeout to prevent blocking the login flow
                    setTimeout(async () => {
                        try {
                            await fetch(`${BaseUrl_1}/api/activity-log`, {
                                method: "POST",
                                headers: { "Content-Type": "application/json" },
                                body: JSON.stringify(activityLogData),
                            });
                            console.log("Activity logged successfully");
                        } catch (logError) {
                            console.error("Failed to log activity:", logError);
                            // Don't show error to user, just log to console
                        }
                    }, 0);
                } catch (logError) {
                    console.error("Activity log setup error:", logError);
                    // Don't let activity log failure affect login
                }

                // SweetAlert and redirect based on role
                Swal.fire({
                    title: 'Login Successful!',
                    text: `Welcome back, ${data.user.first_name}!`,
                    icon: 'success',
                    confirmButtonColor: '#28a745',
                    confirmButtonText: 'Continue'
                }).then(() => {
                    if (data.user.role === 'employer') {
                        navigate("/employer-dashboard");
                    } else if (data.user.role === 'job seeker') {
                        navigate("/jobseeker-dashboard");
                    } else if (data.user.role === 'admin') {
                        navigate("/admindashboard");
                    } else {
                        navigate("/agencydashboard");
                    }

                    window.location.reload(); // Refresh navbar
                });
            }
        } catch (error) {
            console.error("Login error:", error);
            setErrorMsg("Network error or server is down");

            // Log failed login attempt if possible
            try {
                const userAgent = navigator.userAgent;
                let device = "Unknown";
                if (userAgent.includes("Chrome")) device = "Chrome";
                else if (userAgent.includes("Firefox")) device = "Firefox";
                else if (userAgent.includes("Safari")) device = "Safari";

                const failedLogData = {
                    userId: null,
                    userName: email,
                    role: "unknown",
                    action_id: 1, // Login action
                    module_id: 1, // Authentication module
                    description: "Failed login attempt",
                    ipAddress: "Not Available",
                    device: device,
                    status: "FAILED"
                };

                // Log failed attempt (fire and forget)
                fetch(`${BaseUrl_1}/api/activity-log`, {
                    method: "POST",
                    headers: { "Content-Type": "application/json" },
                    body: JSON.stringify(failedLogData),
                }).catch(err => console.error("Failed to log failed attempt:", err));
            } catch (logError) {
                console.error("Error logging failed attempt:", logError);
            }
        }
    };

    return (
        <>
            <Navbar />

            <div className="login-wrapper">
                <Container className="login-container shadow p-4 rounded position-relative" style={{ width: '400px' }}>
                    {/* Close Button */}
                    <button
                        type="button"
                        className="btn-close position-absolute top-0 end-0 mt-2 me-2"
                        onClick={() => navigate('/')}
                        aria-label="Close"
                        style={{
                            fontSize: '0.8rem',
                            padding: '0.5rem',
                            zIndex: 10
                        }}
                    ></button>

                    {/* Logo - Centered */}
                    <div className="d-flex justify-content-center align-items-center mb-3">
                        <img src={logo} alt="Gudnet Logo" style={{ width: '125px' }} />
                    </div>

                    <hr className="mb-4" style={{ borderTop: "3px solid #f8b400", marginTop: "-10px" }} />

                    {/* Text */}
                    <div className="text-center mb-4">

                        <h5 className="fw-bold text-center">Welcome Back !!!</h5>
                        <p className="text-muted mb-1">Please enter your details to log in</p>
                    </div>

                    {/* Error */}
                    {errorMsg && <div className="alert alert-danger py-1">{errorMsg}</div>}

                    {/* Form */}
                    <Form onSubmit={handleLogin}>
                        {/* Email */}
                        <Form.Group className="mb-3">
                            <div className="input-icon">
                                <i className="bi bi-envelope-fill icon"></i>
                                <Form.Control
                                    type="email"
                                    placeholder="Email"
                                    className="input-with-icon"
                                    value={email}
                                    onChange={(e) => setEmail(e.target.value)}
                                    required
                                />
                            </div>
                        </Form.Group>

                        {/* Password */}
                        <Form.Group className="mb-3 position-relative">
                            <div className="input-icon">
                                <i className="bi bi-lock-fill icon"></i>
                                <Form.Control
                                    type={showPassword ? "text" : "password"}
                                    placeholder="Password"
                                    className="input-with-icon pe-5"
                                    value={password}
                                    onChange={(e) => setPassword(e.target.value)}
                                    required
                                />
                                <i
                                    className={`bi ${showPassword ? "bi-eye-slash" : "bi-eye"} eye-icon`}
                                    onClick={() => setShowPassword(!showPassword)}
                                    style={{
                                        position: "absolute",
                                        right: "10px",
                                        top: "50%",
                                        transform: "translateY(-50%)",
                                        cursor: "pointer",
                                        color: "#6c757d"
                                    }}
                                ></i>
                            </div>
                        </Form.Group>

                        {/* Login Button */}
                        <Button className="w-100 login-btn" variant="success" type="submit">
                            LOG IN
                        </Button>
                        <Row className="mb-3 mt-4">
                            <Col className="text-center">
                                <div style={{ fontSize: '0.8rem', whiteSpace: 'nowrap' }}>
                                    <span className="text-muted">Don't have an account? </span>
                                    <span
                                        onClick={() => navigate('/register')}
                                        className="text-primary text-decoration-none fw-semibold"
                                        style={{ cursor: 'pointer' }}
                                    >
                                        Register
                                    </span>
                                    <span className="mx-2">|</span>

                                    <span
                                        onClick={() => navigate('/forgot-password')}
                                        className="text-success text-decoration-none fw-semibold"
                                        style={{ cursor: 'pointer' }}
                                    >
                                        Forgot Password?
                                    </span>
                                </div>
                            </Col>
                        </Row>
                    </Form>
                </Container>
            </div>
        </>
    );
};

export default LoginPage;
